export default {
  active_orders: {
    title: 'Encomendas ativas',
  },
  order_history: {
    title: 'Histórico de encomendas',
  },
  menu: {
    title: 'Menu',
  },
  printer_settings: {
    title: 'Definições da impressora',
  },
  order_control: {
    title: 'Controlo de encomendas',
  },
  busy_mode: {
    title_zero: 'Modo ocupado',
    title_other: 'Modo ocupado (+{{time}} min)',
  },
  volume: {
    title: 'Volume',
  },
  switch_language: {
    title: 'Mudar idioma ({{language}})',
  },
  logout: {
    title: 'Terminar sessão',
    description: 'Tem a certeza que quer terminar sessão?',
    buttons: {
      confirm: 'Sim',
      cancel: 'Cancelar',
    },
  },
  test_restaurant: {
    label: 'Teste',
    tooltip: 'Restaurante de teste: os seus pedidos são testes e nunca é faturado.',
  },
};
